import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../utils/api';

export const kpxQueryKeys = {
  all: ['kpx'],
  smpRange: (params) => [...kpxQueryKeys.all, 'smp-range', params],
  smpToday: (params) => [...kpxQueryKeys.all, 'smp-today', params],
};

export const useKpxSmpRange = (params = {}) => {
  return useQuery({
    queryKey: kpxQueryKeys.smpRange(params),
    queryFn: () => api.get('/kpx/api/smp-range', { params }),
  });
};

export const useKpxSmpToday = (params = {}) => {
  return useQuery({
    queryKey: kpxQueryKeys.smpToday(params),
    queryFn: () => api.get('/kpx/api/smp-range', { params }),
  });
};